import { IModel, IAttribute, ModelConstants } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';

import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.filterActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.Filter),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.Filter)
    ],
    referable: true
})
export class FilterActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly ITEMS: IAttribute;
    public static readonly CONDITION: IAttribute;

    // This property should always be an Expression type.
    @Metamodel.attribute({
        display: stringResources.ItemsLabel,
        templatable: true,
        association: 'ITEMS',
        constraint: {
            required: true
        },
        accepts: ['Array']
    })
    public items: string;

    // This property should always be an Expression type.
    @Metamodel.attribute({
        display: stringResources.ConditionLabel,
        templatable: true,
        accepts: ['Bool'],
        association: 'CONDITION',
        constraint: {
            required: true
        }
    })
    public condition: string;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ControlActivity';
    }
}
